module.exports = __webpack_public_path__ + "static/media/Pa.1db3f59b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/Pa.mp3
// module id = 48
// module chunks = 0